export enum CompromisedSourcingCompanyCriteriaType {
    EmailDomain = 'EmailDomain',
    SourcingCompanyId = 'SourcingCompanyId'
}